import React, { useState, useEffect } from "react";
import { Navigate } from "react-router-dom";

import { useUserContext } from "../../../providers/UserProvider";
import { useFeatureFlag } from "../../../hooks/useFeatureFlag/useFeatureFlag";
import { Unauthorized } from "../../pages/Unauthorized/Unauthorized";
import { getEffectiveRoutesWithPriorities } from "../../../lib/route-priority-utils";
import { Flags } from "../../../feature-flags/flags";

export const NavigateToAuthorized = () => {
    const { getAvailableRoutes } = useUserContext();
    const { enabled: usersLandingEnabled } = useFeatureFlag(Flags.ENABLE_USERS_DEFAULT_LANDING_PAGE);
    const [targetPath, setTargetPath] = useState<string | null>(null);

    useEffect(() => {
        const availableRoutes = getAvailableRoutes();

        // Handle case where no routes are available
        if (!availableRoutes?.length) {
            setTargetPath(null);
            return;
        }

        // Get enabled feature flags
        const enabledFlags: string[] = [];
        if (usersLandingEnabled) {
            enabledFlags.push(Flags.ENABLE_USERS_DEFAULT_LANDING_PAGE);
        }

        // Apply feature flag priority overrides and sort by effective priority
        const effectiveRoutes = getEffectiveRoutesWithPriorities({ routes: availableRoutes, enabledFlags });

        // Find the first route with a valid path
        const firstValidRoute = effectiveRoutes.find((route) => route.path);
        setTargetPath(firstValidRoute?.path || null);
    }, [usersLandingEnabled, getAvailableRoutes]);

    if (targetPath === null) {
        return <Unauthorized />;
    }

    return <Navigate to={targetPath} replace />;
};

NavigateToAuthorized.displayName = "NavigateToAuthorized";
